import { apiService } from "./base-api-service/base-api-service";
import { endPoints, getOrchestrationServiceEndPoint } from "./base-url/api-constants";
import { readCookie } from "../Util/helper";

class OrchestrationService {
  OrchestrationService(url:any) {
    return getOrchestrationServiceEndPoint(url);
  }
  checkoutProcess(data: any) {
    const createOrchestrationProcessEndpoint = this.OrchestrationService(
      `${endPoints.orchestrationService.CHECKOUT}`
    );
    const jwtToken = readCookie("jwtToken"); //localStorage.getItem("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    return apiService.post(createOrchestrationProcessEndpoint, data, headers);
  }

  checkoutProcess3DS(data: any) {
    const createOrchestrationProcessEndpoint = this.OrchestrationService(
      `${endPoints.orchestrationService.CHECKOUT_3DS}`
    );
    const jwtToken = readCookie("jwtToken"); //localStorage.getItem("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    return apiService.post(createOrchestrationProcessEndpoint, data, headers);
  }

  getBillingInfo(userGuid: any, locale: any) {
    const bilingInfoEndpoint = this.OrchestrationService(
      `${endPoints.orchestrationService.BILLING_INFO.replace(
        ":userGuid",
        userGuid
      ).replace(":localeVal", locale)}`
    );
    const jwtToken = readCookie("jwtToken"); //localStorage.getItem("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    return apiService.get(bilingInfoEndpoint, null, headers);
  }

  cancelUserByUserGuid(data:any, userGUID:any) {
    const cancelUserEndpoint = this.OrchestrationService(
      `${endPoints.orchestrationService.CANCEL_USER.replace(
        ":userGuid",
        userGUID
      )}`
    );
    const jwtToken = readCookie("jwtToken"); //localStorage.getItem("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    return apiService.put(cancelUserEndpoint, data, headers);
  }

  restartSubscription(data:any, userGUID:any) {
    const restartSubscriptionEndpoint = this.OrchestrationService(
      `${endPoints.orchestrationService.RESTART_SUB.replace(
        ":userGuid",
        userGUID
      )}`
    );
    const jwtToken = readCookie("jwtToken"); //localStorage.getItem("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    return apiService.post(restartSubscriptionEndpoint, data, headers);
  }

  setConfirmationinCB(userGUID:any) {
    const confirmationinCBEndpoint = this.OrchestrationService(
      `${endPoints.orchestrationService.SET_CONFIRMATION.replace(
        ":userGuid",
        userGUID
      )}`
    );
    const jwtToken = readCookie("jwtToken"); //localStorage.getItem("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    return apiService.put(
      confirmationinCBEndpoint,
      JSON.stringify("true"),
      headers
    );
  }

  getUserPlan(userGuid:any, data:any) {
    const PlanEndpoint = this.OrchestrationService(
      `${endPoints.orchestrationService.GET_USER_PLANS.replace(
        ":userGuid",
        userGuid
      )}`
    );
    const jwtToken = readCookie("jwtToken"); //localStorage.getItem("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    return apiService.post(PlanEndpoint, data, headers);
  }
  getGatewayAbtestResponse(cardtoken:any, currency:any, portal:any) {
    const gatewayABtestEndpoint = this.OrchestrationService(
      `${endPoints.orchestrationService.GATEWAY_ABTEST.replace(
        ":cardtoken",
        cardtoken
      )
        .replace(":currency", currency)
        .replace(":portal", portal)}`
    );
    const jwtToken = readCookie("jwtToken"); //localStorage.getItem("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    return apiService.get(gatewayABtestEndpoint, null, headers);
  }
}

export default new OrchestrationService();
